import {
  END_BULK_DELETE_TASKS,
  END_BULK_REMOVE_TASKS,
  START_BULK_DELETE_TASKS,
  START_BULK_REMOVE_TASKS
} from '../actions/tasks';

export default function(state = {}, action) {
  switch (action.type) {
  case END_BULK_DELETE_TASKS:
    return {
      ...state,
      startBulkDeleteTasks: false
    };
  case END_BULK_REMOVE_TASKS:
    return {
      ...state,
      startBulkRemoveTasks: false
    };
  case START_BULK_DELETE_TASKS:
    return {
      ...state,
      startBulkDeleteTasks: true
    };
  case START_BULK_REMOVE_TASKS:
    return {
      ...state,
      startBulkRemoveTasks: true
    };
  }
  return { ...state };
}
